import { GET_DURATION, ADD_DURATION } from '../types'

const INITIAL_STATE = {
  allduration: [],
}

const configTwoReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_DURATION:
      return {
        ...state,
        allduration: payload.data,
      }
    case ADD_DURATION:
      return {
        ...state,
        allduration: payload.data,
      }
    default:
      return state
  }
}

export default configTwoReducer
